import BaseService from '@/utils/base-service';
import { ApiResponse, Application, ApiResponseList } from '@/models';
import { Api } from '@coode/fe-sdk';
import { sdk } from '@/utils/sdk';

/**
 * @name AppService
 * @description This class is used to query the identity server for user related data,
 * which is not related to authentication.
 */
export class AppService extends BaseService {
    constructor() {
        super('use-cases');
    }

    protected get api(): Api {
        return sdk.core.metaData.request.api
    }

    public async getApps(): Promise<ApiResponse<ApiResponseList<Application>>> {
        return (await this.api.get<ApiResponse<ApiResponseList<Application>>>(`${this.resourcePath}`)).data;
    }
}
